import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "caret-right",
  "use": "caret-right-usage",
  "viewBox": "0 0 9 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 28\" id=\"caret-right\"><path fill=\"currentColor\" d=\"M9 14a.99.99 0 01-.297.703l-7 7A.996.996 0 011 22c-.547 0-1-.453-1-1V7c0-.547.453-1 1-1a.99.99 0 01.703.297l7 7A.996.996 0 019 14z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol